import { NgModule, NO_ERRORS_SCHEMA } from "@angular/core";
import { JwtParserService } from "./services/jwt-parser.service";
import { ModalService } from "./services/modal.service";
import { AuthGuard } from "./services/auth.guard";
import { RouterModule } from "@angular/router";
import { ModalModule } from "ngx-bootstrap/modal";
import { CommonModule } from "@angular/common";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { HTTP_INTERCEPTORS } from "@angular/common/http";
import { ApiInterceptor } from "./services/interceptor/api.interceptor";
import { TooltipModalComponent } from "./components/tooltip-modal/tooltip-modal.component";
import { ToasterComponent } from './components/toaster/toaster/toaster.component';
import {LeftNavigationComponent} from "./components/left-navigation/left-navigation.component";
import {TrimStr} from "./pipes/trim.pipe";
import {MaskCardPipe} from "./pipes/mask-card.pipe";
import {DomSanitizerPipe} from "./pipes/dom-sanitizer.pipe";

@NgModule({
  declarations: [
    TooltipModalComponent,
    ToasterComponent,
    LeftNavigationComponent,
    TrimStr,
    MaskCardPipe,
    DomSanitizerPipe,
  ],
  imports: [
    CommonModule,
    RouterModule,
    FormsModule,
    ReactiveFormsModule,
    ModalModule.forRoot(),
  ],
  exports: [TooltipModalComponent,ToasterComponent, LeftNavigationComponent, TrimStr,
    MaskCardPipe,
    DomSanitizerPipe],
  providers: [
    JwtParserService,
    AuthGuard,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: ApiInterceptor,
      multi: true,
    },
    ModalService,
  ],
  schemas: [NO_ERRORS_SCHEMA], // required for svg custom properties
})
export class SharedModule {}
